export default __webpack_public_path__ + "static/media/crdb-logo.41e2c6df.svg";